import { Box, Typography, useTheme } from "@mui/material";

import { NavSection } from "./LeftNavDrawerV2";
import { NAV_SECTION_ROW_HEIGHT, NAV_SECTION_ROW_PADDING_TOP } from "./navMetrics";

/**
 * Section heading row. Both states render the same fixed-height row with the
 * divider line at the same vertical position, so collapsing/expanding the nav
 * doesn't shift the rows around it — the title disappears and the divider
 * grows to full width, nothing else moves.
 */
export function SectionNavRow({ section, collapsed }: { section: NavSection; collapsed: boolean }) {
  const { title, textColor, sx, variant } = section;
  const theme = useTheme();
  // Customer headings get the subtle teal divider; staff keeps the pumpkin accent.
  const dividerColor =
    variant === "staff" ? theme.palette.nav.staffIcon : theme.palette.nav.divider;
  if (collapsed) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: "16px",
          pt: `${NAV_SECTION_ROW_PADDING_TOP}px`,
          pb: 0,
          // Same row height as the expanded heading, with the divider centered
          // on where the text line sits.
          minHeight: `${NAV_SECTION_ROW_HEIGHT}px`,
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: "2px",
            backgroundColor: dividerColor,
            minWidth: 0,
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        px: "16px",
        py: `${NAV_SECTION_ROW_PADDING_TOP}px`,
        pb: "0px",
        minHeight: `${NAV_SECTION_ROW_HEIGHT}px`,
        boxSizing: "border-box",
        ...sx,
      }}
    >
      <Typography
        sx={{
          color: textColor ?? "white",
          fontSize: "12px",
          fontWeight: 400,
          fontStyle: "normal",
          lineHeight: "24px",
          letterSpacing: "1px",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          flex: 1,
          height: "2px",
          backgroundColor: dividerColor,
          minWidth: 0,
        }}
      />
    </Box>
  );
}
